import * as React from 'react';

import { BreadCrumbs } from '@common/react/components/UI/BreadCrumbs/BreadCrumbs';
import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';

import { Location } from '@app/objects/Location';
import ClinicCard from '@app/components/Pages/Clinics/ClinicCard';

import noImage from '@images/no-image.jpg';

import '@app/scss/pages/clinicsPage.scss';

export const getClinicAvatar = (location: Location, addRemote: boolean = true): string => {
	if (location.portalOriginalAvatar) {
		return addRemote ? `/remote/${location.portalOriginalAvatar}` : location.portalOriginalAvatar;
	}
	if (location.portalAvatar) {
		return addRemote ? `/remote/${location.portalAvatar}` : location.portalAvatar;
	}
	return noImage;
};

const Clinics: React.FC = () => {
	return <ServerPageProvider
		defaultTitle="Clinics"
		inner={(serverPage) =>
			<div className="clinics-page container">
				<BreadCrumbs
					title="Clinics"
				/>
				{serverPage.items && serverPage.items.list.map((location: Location) => <ClinicCard key={location.id} location={location} />)}
			</div>
		}
	/>;
};

export default Clinics;
